import { Record, Map } from 'immutable';
import trainTime from '../../lib/TrainTime';
import { resolve } from '../../helpers/LinkMapper';
import InAppStore from "../../stores/InAppStore";

const defaults = {
    customer: null,
    tokenType: null,
    accessToken: null,
    expires: null,
    refreshToken: null,
    itsoSession: null,
    customerDevice: null,
    showPasswordChangeModal: null,
};

class AuthToken extends Record(defaults) { // eslint-disable-line new-cap

    static fromJSON(json = {}) {
        const tokenData = {
            customer: resolve(json.customer).with(Map),
            tokenType: resolve(json.tokenType).with(String),
            accessToken: resolve(json.accessToken).with(String),
            expires: trainTime(json.expires),
            refreshToken: resolve(json.refreshToken).with(String),
            itsoSession: resolve(json.itsoSession).with(Map),
            customerDevice: json.customerDevice,
            showPasswordChangeModal: resolve(json.showPasswordChangeModal).with(Boolean),
        };
        return new AuthToken(tokenData);
    }

    getCustomerId () {
        return this.customer ? this.customer.get('id') : undefined;
    }

    isValid () {
        if (InAppStore.isInApp()) {
            return this.accessToken && this.expires && this.expires.isAfter(trainTime());
        } else {
            return this.accessToken;
        }
    }
}

export default AuthToken;
